<template>
  <div>
    <div class="page-menu" :class="pageCode">
      <SwipeMenu v-if="showMenu" class="buttons"
              :loop="true"
              :currentPage="currentPage"
              :itemWidth="192"
              @move="onSliderMove"
              @touch-end="onTouchEnd"
              @change-page="onSlideChangePage">
        <div class="infinity-swipe-item" v-for="(button, index) in buttons" :key="index">
          <button
            :class="{active: currentPage==index+1, disabled: button.disabled}"
            @click="onButtonClick(index+1)">
            {{button.name}}
          </button>
        </div>
      </SwipeMenu>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
  import SwipeMenu from 'vue-swipe-menu';
  import 'vue-swipe-menu/dist/vue-swipe-menu.css'

  export default {
    name: 'Home',
    components: {
      SwipeMenu: SwipeMenu
    },
    data () {
      return {
        touch_time: 0,
        currentPage: 2,
        buttons: [
          {code: 'favorite', name: 'お気に入り', disabled: false},
          {code: 'popular', name: '人気', disabled: false},
          {code: 'category', name: 'カテゴリ', disabled: false},
          {code: 'searchHistory', name: '検索履歴', disabled: false},
        ],
        busy: false
      };
    },
    computed: {
      pageCode () {
        return this.buttons[this.currentPage - 1].code;
      },
      showMenu () {
        const list = [
          'popularItem',
          'favoriteItem',
          'categoryItem',
        ];
        if (list.indexOf(this.$route.name) > -1) {
          return false;
        } else {
          return true;
        }
      }
    },
    created () {
      this.initialize();
    },
    methods: {
      initialize () {
        for (let i = 0; i < this.buttons.length; i++) {
          if (this.buttons[i].code === this.$route.name) {
            this.currentPage = i + 1;
          }
        }
      },
      onButtonClick: function (page) {
        if (this.touch_time < 300) {
          this.onSlideChangePage(page);
        }
      },
      onSlideChangePage: function (page) {
        this.$set(this, 'currentPage', page);
        this.$router.push({path: '/h/' + this.buttons[page - 1].code + '/'}, ()=>{});
      },
      onTouchEnd: function (page, touchTime) {
        this.touch_time = touchTime;
      },
      onSliderMove: function (page) {
        if (page <= 0) page = 1;
        if (page > this.buttons.length) page = this.buttons.length;

        if (page !== this.currentPage) {
          this.onSlideChangePage(page);
        }
      }
    },
    watch: {
      '$route'() {
        this.initialize();
      }
    }
  };
</script>

<style scoped lang="scss">
  .buttons {
    /*width: 100%;*/
    background-color: rgba(0, 0, 0, 0.5);
    overflow: hidden;
    button {
      width: 10rem;
      margin: .5rem 1rem;
      height: 40px;
      border-radius: 20px;
      border: 0;
      color: rgb(128, 127, 128);
      background-color: #f0f0f0;
      &.active {
        color: #000;
      }
    }
  }
  .page-menu {
    position: sticky;
    top: 48px;
    z-index: 1000;
  }
</style>
